<template>
  <v-card outlined elevation="0" style="border: none">
    <v-card-title>
      <h3>{{ sr.title }} ({{ sr.ticketid }})</h3>
    </v-card-title>
    <v-card-text class="pt-3">
      <v-row class="px-2 mb-2">
        <v-col>
          <div>
            <span class="mtitle"
              >{{ $t("message.pageKm.loco", { value: "default" }) }}:</span
            >
            <span class="value">{{ sr.assetnum }}</span>
          </div>

          <div>
            <span class="mtitle"
              >{{ $t("message.magic.status", { value: "default" }) }}:</span
            >
            <span class="value">{{ getStatusText(sr.status) }}</span>
          </div>

          <div>
            <span class="mtitle"
              >{{ $t("message.magic.priority", { value: "default" }) }}:</span
            >
            <span class="value">{{ sr.priority }}</span>
          </div>
          <div>
            <span class="mtitle"
              >{{
                $t("message.magic.reportedDate", { value: "default" })
              }}:</span
            >
            <span class="value">{{ formatdate(sr.reportdate) }}</span>
          </div>
        </v-col>
        <v-col>
          <div>
            <span class="mtitle"
              >{{ $t("message.magic.desc", { value: "default" }) }}:</span
            >
            <span class="value" v-html="sr.description"></span>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mb-1" v-if="showAttachment()"></v-divider>

      <v-row class="px-2" v-if="showAttachment()">
        <v-col>
          <div>
            <span class="mtitle">
              {{ $t("message.magic.attachements", { value: "default" }) }}
            </span>
          </div>
          <v-data-table
            dense
            :headers="headersProtocol"
            :items="attachments"
            light
          >
            <template v-slot:[`item.createdate`]="{ item }">
              {{ formatdate(item.createdate) }}
            </template>
            <template
              v-slot:[`item.document`]="{ item }"
              @click="downloadProtocol(item)"
            >
              {{ item.documentName }}
              <v-icon @click="downloadProtocol(item)"> mdi-download</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatMagicDate } from "@/shared/DateHelper";
import { getSrStatusText } from "@/shared/Helper";
import MaximoService from "@/services/MaximoService";
export default {
  props: ["sr", "attachments"],

  methods: {
    showAttachment() {
      if (this.attachments.length > 0) {
        return true;
      }
      return false;
    },

    //show sr status
    getStatusText(state) {
      return this.$t(getSrStatusText(state), { value: "default" });
    },

    formatdate(date) {
      return formatMagicDate(date);
    },

    downloadProtocol(item) {
      let file_path = MaximoService.downloadProtocol(item.doclinksid);
      window.open(file_path);
    },
  },

  computed: {
    headersProtocol() {
      return [
        {
          text: this.$t("message.magic.date", { value: "default" }),
          value: "createdate",
        },
        {
          text: this.$t("message.magic.details", { value: "default" }),
          value: "document",
        },
      ];
    },
  },
};
</script>

<style scoped>
.dp {
  color: #00475a;
  font-weight: bolder;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #fff;
  font-size: 16px;
}

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bolder;
}

.value {
  font-size: 16px;
}
</style>
